import moment from 'moment';
import { ClipAvailabilityStatus } from '../types/clip-availability';
import { Clip } from '../types/clip-types';
import {
  isClipFromRecordingStudio,
  isClipCompositeMp4Available,
  isClipLiveEvent,
  isClipAlignedStreamAvailable,
  isClipLiveEventAndRemotionMigrationInProgress
} from './clipUtils';
import { isLiveEventWithAutoMigration } from './mediaContentUtils';

export const getClipAvailabilityStatus = ({
  clip,
  isSharedPage,
  rsTestDate
}: {
  clip: Clip;
  isSharedPage: boolean;
  rsTestDate: number;
}) => {
  const isCompositeMp4Applicable = !isClipFromRecordingStudio(clip);
  if (isCompositeMp4Applicable && !isClipCompositeMp4Available(clip) && !isSharedPage) {
    return ClipAvailabilityStatus.COMPOSITE_MP4_NOT_READY;
  }
  if (isClipLiveEvent(clip) && isLiveEventWithAutoMigration(clip.content) && !isClipAlignedStreamAvailable(clip)) {
    // New live event
    return ClipAvailabilityStatus.ALIGNED_STREAM_NOT_READY;
  }

  if (isClipLiveEventAndRemotionMigrationInProgress(clip)) {
    // Old live event
    return ClipAvailabilityStatus.LIVE_EVENT_MIGRATION_IN_PROGRESS;
  }

  if (isClipFromRecordingStudio(clip) && !isClipAlignedStreamAvailable(clip)) {
    return ClipAvailabilityStatus.ALIGNED_STREAM_NOT_READY;
  }

  if (isClipFromRecordingStudio(clip)) {
    const createdAfterTestDate = rsTestDate && moment(clip.content.live_end_time).isAfter(moment(rsTestDate));
    if (!createdAfterTestDate) {
      return ClipAvailabilityStatus.RECORDING_STUDIO_UNSUPPORTED_EVENT;
    }
  }
  return ClipAvailabilityStatus.ALL_OK;
};
